var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateOrganizationSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 151,
    viewBox: "0 0 218 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ivcw2rq8za)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218 143.413H0v.131h218v-.131zM187.349 146.418h-42.554v.131h42.554v-.131zM146.365 148.901h-20.361v.131h20.361v-.131zM196.156 150.426h-8.371v.131h8.371v-.131zM95.484 148.989h-40.33v.13h40.33v-.13zM51.274 148.989h-8.677v.13h8.677v-.13zM39.545 147.115H25.201v.131h14.344v-.131zM103.332 123.985H19.141c-1.352 0-2.486-1.133-2.486-2.483V3.279c0-1.35 1.134-2.483 2.485-2.483h84.192c1.352 0 2.485 1.132 2.485 2.483v118.223a2.456 2.456 0 0 1-2.485 2.483zM19.141.927a2.39 2.39 0 0 0-2.398 2.395v118.223a2.39 2.39 0 0 0 2.398 2.396h84.191a2.39 2.39 0 0 0 2.398-2.396V3.279a2.39 2.39 0 0 0-2.398-2.396H19.141v.044zM197.639 123.985h-84.192c-1.351 0-2.485-1.133-2.485-2.483V3.279c0-1.35 1.134-2.483 2.485-2.483h84.192c1.351 0 2.485 1.132 2.485 2.483v118.223a2.456 2.456 0 0 1-2.485 2.483zM113.447.927a2.39 2.39 0 0 0-2.398 2.395v118.223a2.39 2.39 0 0 0 2.398 2.396h84.192a2.39 2.39 0 0 0 2.398-2.396V3.279a2.39 2.39 0 0 0-2.398-2.396h-84.192v.044z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.52 139.405H38.804l-7.848-89.212h131.716l7.848 89.212z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.493 142.28 2.311-2.875-7.848-89.212-2.31 2.875 7.847 89.212z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.548 136.051-7.237-82.242c-.088-.871.61-1.612 1.482-1.612h124.653c.784 0 1.395.567 1.482 1.35l7.238 82.199c.087.871-.611 1.612-1.483 1.612H42.031c-.742.043-1.396-.566-1.483-1.307z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.334 139.405H37.496l-1.395 4.008h19.838l1.395-4.008z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.334 139.405h130.451l-1.395 4.008H55.939l1.395-4.008z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.049 139.405h25.027l-.306 2.657h-24.982l.261-2.657zM148.938 44.313h31.61c2.616 17.337-9.505 31.581-26.814 31.581-5.538 0-11.206-1.438-16.438-4.225l11.642-27.356z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.938 44.313 16.655-24.177a40.144 40.144 0 0 1 9.984 10.847c2.573 4.182 4.273 8.712 4.971 13.33h-31.61z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.937 44.313-4.752-31.582c3.706 0 7.456.654 11.074 1.917 3.663 1.263 7.151 3.136 10.334 5.489l-16.656 24.176z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.938 44.313-11.685 27.356c-10.595-5.62-18.225-16.074-19.925-27.356-2.616-17.337 9.505-31.582 26.814-31.582l4.796 31.582z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.959 100.636h28.035c.349 2.44.436 4.879.131 7.231a23.756 23.756 0 0 1-1.788 6.752l-26.378-13.983z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.959 100.636.698-27.573c6.671 1.132 13.036 4.53 18.05 9.583 5.014 5.053 8.284 11.413 9.287 17.99h-28.035z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.959 100.636-24.895 9.584c-1.57-3.05-2.66-6.317-3.14-9.584-2.31-15.376 8.415-28.009 23.806-28.009 1.613 0 3.27.13 4.927.436l-.698 27.573z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.959 100.636 26.378 13.983c-3.706 8.669-12.164 13.983-22.148 13.983-11.772 0-23.414-7.405-29.125-18.426l24.895-9.54zM104.901 81.12H65.618c-2.485 0-4.709-2.047-4.883-4.53l-1.962-24.132c-.218-2.483 1.656-4.53 4.142-4.53h39.283c2.485 0 4.709 2.047 4.883 4.53l1.962 24.133c.218 2.526-1.656 4.53-4.142 4.53z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.902 81.339H65.618c-2.616 0-4.883-2.09-5.101-4.704l-1.962-24.133c-.087-1.263.305-2.44 1.133-3.354.829-.915 1.962-1.394 3.227-1.394h39.283c2.616 0 4.884 2.09 5.102 4.704l1.962 24.133c.087 1.263-.306 2.44-1.134 3.354a4.414 4.414 0 0 1-3.226 1.394zM62.915 48.146c-1.134 0-2.18.435-2.965 1.263a4.091 4.091 0 0 0-1.046 3.05l1.962 24.132c.174 2.396 2.31 4.356 4.709 4.356h39.283c1.134 0 2.18-.436 2.965-1.263a4.092 4.092 0 0 0 1.046-3.05l-1.962-24.132c-.174-2.396-2.311-4.356-4.709-4.356H62.915z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.22 74.109a12.251 12.251 0 0 1-5.755 3.484l-.654-1.873c4.84-1.307 8.11-5.837 7.673-11.195-.261-3.18-1.787-6.098-4.055-8.19l1.265-1.35c5.668 5.271 6.365 13.853 1.526 19.124z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.694 54.984-1.265 1.35c-2.267-2.09-5.276-3.397-8.458-3.397-3.183 0-5.974 1.307-7.892 3.398l-1.482-1.35c2.31-2.527 5.668-3.965 9.243-3.965 3.531.044 7.107 1.438 9.853 3.964z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.465 77.593c-4.535 1.263-9.636-.087-13.342-3.485-5.668-5.227-6.366-13.852-1.57-19.08l1.483 1.35c-1.919 2.092-2.965 4.967-2.704 8.19.524 6.404 6.148 11.587 12.514 11.587 1.046 0 2.049-.13 2.965-.392l.653 1.83z",
    fill: "url(#5l3yngm5wb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.405 8.941h-3.14v.392h3.14v-.392zM45.17 8.941h-7.15v.392h7.15v-.392z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.524 43.616h-39.24c-2.485 0-4.709-2.047-4.883-4.53l-1.962-24.133c-.218-2.483 1.656-4.53 4.142-4.53h39.283c2.485 0 4.709 2.047 4.883 4.53l1.962 24.133c.218 2.526-1.656 4.53-4.185 4.53z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.524 43.833h-39.24c-2.616 0-4.883-2.09-5.101-4.704L32.22 14.996c-.087-1.263.305-2.439 1.133-3.354.829-.915 1.962-1.394 3.227-1.394h39.283c2.616 0 4.883 2.091 5.102 4.705l1.962 24.132c.087 1.264-.306 2.44-1.134 3.355a4.513 4.513 0 0 1-3.27 1.393zM36.58 10.64c-1.134 0-2.18.436-2.965 1.263a4.091 4.091 0 0 0-1.047 3.05l1.962 24.132c.175 2.396 2.311 4.356 4.71 4.356h39.283c1.133 0 2.18-.435 2.965-1.263a4.09 4.09 0 0 0 1.046-3.05l-1.962-24.132c-.174-2.396-2.31-4.356-4.709-4.356H36.581z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.97 17.393h20.797l-.174-2.091H35.796l.174 2.09z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.565 17.393H56.768l-.175-2.091H77.39l.175 2.09z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.406 22.707h5.93l-.175-2.048h-5.93l.175 2.048z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.001 22.707H42.336l-.174-2.048h35.665L78 22.707z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.842 28.065h18.53l-.174-2.047h-18.53l.174 2.047z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.437 28.065H55.373l-.175-2.047h23.065l.174 2.047z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.279 33.422h31.61l-.175-2.047h-31.61l.175 2.047z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.873 33.422h-9.985l-.174-2.047h9.984l.175 2.047z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.714 38.78H52.32l-.174-2.09H37.54l.174 2.09z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.309 38.78H52.32l-.174-2.09h26.988l.175 2.09z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vz9q3h26xc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.239 43.615H92.955c-2.485 0-4.709-2.047-4.883-4.53L86.11 14.952c-.218-2.483 1.657-4.53 4.142-4.53h39.284c2.485 0 4.708 2.047 4.883 4.53l1.962 24.133c.218 2.526-1.657 4.53-4.142 4.53z",
    fill: "#407BFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.239 43.833H92.955c-2.615 0-4.883-2.09-5.1-4.704l-1.963-24.133c-.087-1.263.306-2.439 1.134-3.354.828-.915 1.962-1.394 3.226-1.394h39.284c2.616 0 4.883 2.091 5.101 4.705l1.962 24.132c.087 1.264-.305 2.44-1.133 3.355a4.416 4.416 0 0 1-3.227 1.393zM90.252 10.64c-1.133 0-2.18.436-2.965 1.263a4.091 4.091 0 0 0-1.046 3.05l1.962 24.132c.174 2.396 2.31 4.356 4.709 4.356h39.284a4.02 4.02 0 0 0 2.964-1.263 4.089 4.089 0 0 0 1.047-3.05l-1.962-24.132c-.175-2.396-2.311-4.356-4.709-4.356H90.252z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.209 118.322H50.925c-2.485 0-4.709-2.047-4.883-4.53L44.08 89.659c-.218-2.483 1.657-4.53 4.142-4.53h39.283c2.486 0 4.71 2.047 4.884 4.53l1.962 24.133c.218 2.483-1.657 4.53-4.142 4.53z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.209 118.54H50.925c-2.616 0-4.883-2.091-5.101-4.705l-1.962-24.132c-.087-1.263.305-2.44 1.134-3.354.828-.915 1.962-1.394 3.226-1.394h39.284c2.616 0 4.883 2.091 5.1 4.705l1.963 24.132c.087 1.263-.305 2.439-1.134 3.354a4.416 4.416 0 0 1-3.226 1.394zM48.222 85.347c-1.134 0-2.18.436-2.965 1.263a4.09 4.09 0 0 0-1.046 3.05l1.962 24.132c.174 2.396 2.31 4.356 4.709 4.356h39.283c1.134 0 2.18-.436 2.965-1.264a4.089 4.089 0 0 0 1.046-3.049l-1.962-24.132c-.174-2.396-2.31-4.356-4.708-4.356H48.222z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.541 101.159 62 110.917l9.722-14.942 5.974 7.711 1.482-2.222 9.81 11.718h-37.67l2.223-12.023z",
    fill: "url(#05qscmubyd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.794 101.769-3.924 8.407-12.556-19.907-5.886 12.633-1.919-2.963-6.191 13.243h37.67l-7.194-11.413z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.891 39.378c.718.618 1.781.618 2.313 0l15.649-18.172c.533-.618.375-1.669-.343-2.287l-2.583-2.225c-.718-.618-1.718-.618-2.25 0l-12.775 14.834-8.1-6.922c-.719-.619-1.719-.619-2.25 0l-1.917 2.225c-.532.618-.375 1.669.343 2.287l11.913 10.26z",
    fill: "url(#b8h868s2ee)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.483 38.583c.718.618 1.78.618 2.312 0l15.65-18.172c.532-.618.374-1.669-.343-2.287l-2.584-2.225c-.718-.618-1.718-.618-2.25 0l-12.775 14.834-8.101-6.923c-.718-.618-1.718-.618-2.25 0l-1.916 2.226c-.532.618-.375 1.668.343 2.286l11.914 10.26z",
    fill: "url(#vr13qjbzpf)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.074 36.196c.718.618 1.78.618 2.313 0l15.649-18.171c.532-.619.375-1.67-.343-2.287l-2.584-2.226c-.717-.618-1.717-.618-2.25 0l-12.775 14.834-8.101-6.922c-.717-.618-1.717-.618-2.25 0l-1.916 2.225c-.532.618-.374 1.669.343 2.287l11.914 10.26z",
    fill: "url(#3rfob79dvg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.329 31.46 1.654 1.957 4.711-1.958-1.337-2.02-5.028 2.02z",
    fill: "url(#4joa0ohdqh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.92 38.19a2.386 2.386 0 1 1-2.387-2.387 2.386 2.386 0 0 1 2.387 2.387z",
    fill: "url(#r4oku9edpi)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.628 4.376a1.193 1.193 0 1 1-2.387 0 1.193 1.193 0 1 1 2.387 0z",
    fill: "url(#p415ihh5vj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.577 85.131a.816.816 0 0 1-.796.796.816.816 0 0 1-.796-.796c0-.424.372-.795.796-.795.424 0 .796.318.796.795z",
    fill: "url(#ca6r6qox4k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.482 69.901 2.735.114 1.243-4.774-2.486.114-1.492 4.546z",
    fill: "url(#esxkig14il)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.219 104.113 2.735.113 1.243-4.774-2.486.114-1.492 4.547z",
    fill: "url(#381fumv69m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.029.64.897 2.628 5.507-.961L145.28 0l-5.251.64z",
    fill: "url(#mggoxgicdn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.861 127.94.897 2.627 5.507-.961-1.153-2.307-5.25.641z",
    fill: "url(#13r5tkszjo)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.018 27.05-1.88 2.187 4.038 4.179 1.532-2.25-3.69-4.115z",
    fill: "url(#k33pebm6ap)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5l3yngm5wb",
    x1: 79.416,
    y1: 55.028,
    x2: 79.416,
    y2: 78.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "05qscmubyd",
    x1: 70.153,
    y1: 95.975,
    x2: 70.153,
    y2: 113.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b8h868s2ee",
    x1: 104.73,
    y1: 12.182,
    x2: 104.73,
    y2: 37.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#01D0EC",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vr13qjbzpf",
    x1: 106.321,
    y1: 11.387,
    x2: 106.321,
    y2: 36.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#01D0EC",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3rfob79dvg",
    x1: 107.913,
    y1: 9,
    x2: 107.913,
    y2: 34.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#01D0EC",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4joa0ohdqh",
    x1: 159.479,
    y1: 31.022,
    x2: 162.554,
    y2: 35.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4oku9edpi",
    x1: 48.533,
    y1: 35.803,
    x2: 48.533,
    y2: 40.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p415ihh5vj",
    x1: 66.434,
    y1: 3.183,
    x2: 66.434,
    y2: 5.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca6r6qox4k",
    x1: 148.781,
    y1: 84.336,
    x2: 148.781,
    y2: 85.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esxkig14il",
    x1: 22.201,
    y1: 67.141,
    x2: 25.761,
    y2: 69.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "381fumv69m",
    x1: 178.938,
    y1: 101.352,
    x2: 182.497,
    y2: 103.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mggoxgicdn",
    x1: 143.231,
    y1: 0,
    x2: 143.231,
    y2: 3.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "13r5tkszjo",
    x1: 101.063,
    y1: 127.299,
    x2: 101.063,
    y2: 130.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E59EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A338E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k33pebm6ap",
    x1: 12.146,
    y1: 29.584,
    x2: 16.972,
    y2: 33.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ivcw2rq8za"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h218v151H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vz9q3h26xc",
    x: 78.093,
    y: 6.422,
    width: 66.305,
    height: 49.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12271_55077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12271_55077",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateOrganizationSuccessIcon);
export default __webpack_public_path__ + "static/media/CreateOrganizationSuccessIcon.58cdf6b3.svg";
export { ForwardRef as ReactComponent };